import { injectQualtricsScript } from '@highmark-web/highmark-common';

const QUALTRICS_LIVE_CHAT_INTERCEPTOR_ELEMENT_ID = 'ZN_9RD75oTV3Erq0WW';
const QUALTRICS_LIVE_CHAT_INTERCEPTOR_COOKIE_ID = 'QSI_S_ZN_9RD75oTV3Erq0WW';
const QUALTRICS_LIVE_CHAT_INTERCEPTOR_SRC =
  'https://zn9rd75otv3erq0ww-highmark.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_9RD75oTV3Erq0WW';

export function injectLiveChatQualtricsScript() {
  injectQualtricsScript({
    elementId: QUALTRICS_LIVE_CHAT_INTERCEPTOR_ELEMENT_ID,
    cookieId: QUALTRICS_LIVE_CHAT_INTERCEPTOR_COOKIE_ID,
    src: QUALTRICS_LIVE_CHAT_INTERCEPTOR_SRC,
  });
}
